/**
 * Rewrite root-relative /static/... asset URLs to absolute FE origin URLs.
 * PDF export HTML is rendered on a remote host that cannot resolve `/static/...`.
 *
 * @param {string} html
 * @param {string} [origin]
 * @returns {string}
 */
export default function absolutizeExportHtmlAssets(html, origin) {
  if (!html) return html;

  const base =
    (origin || (typeof window !== 'undefined' ? window.location?.origin : '') || '').replace(/\/$/, '');
  if (!base) return html;

  return html
    .replace(/(\s(?:src|href))=("|')(\/static\/[^"']+)\2/gi, (_, attr, quote, path) => `${attr}=${quote}${base}${path}${quote}`)
    .replace(/url\((['"]?)(\/static\/[^'")]+)\1\)/gi, (_, quote, path) => `url(${quote}${base}${path}${quote})`);
}
